import { create } from 'zustand';
import type { OSDHandle } from '../viewer/createViewer';
import OpenSeadragon from 'openseadragon';
import type { PointRecord } from '../types';

type Filters = {
  faction: Set<string>;
  segmentum: Set<string>;
  type: Set<string>;
};

type MapState = {
  points: PointRecord[];
  viewer: OSDHandle | null;
  sidebarOpen: boolean;
  searchQuery: string;
  selectedId: string | null;
  filters: Filters;
  clusteringEnabled: boolean;
  setPoints: (p: PointRecord[]) => void;
  setViewer: (v: OSDHandle | null) => void;
  setSidebarOpen: (open: boolean) => void;
  setSearchQuery: (q: string) => void;
  setSelectedId: (id: string | null) => void;
  setFilters: (f: Partial<Filters>) => void;
  setClusteringEnabled: (value: boolean) => void;
  centerOnById: (id: string, zoom?: number) => void;
};

export const useMapStore = create<MapState>((set) => ({
  points: [],
  viewer: null,
  sidebarOpen: true,
  searchQuery: '',
  selectedId: null,
  filters: { faction: new Set(), segmentum: new Set(), type: new Set() },
  clusteringEnabled: false,
  setPoints: (p) => set({ points: p }),
  setViewer: (v) => set({ viewer: v }),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setSearchQuery: (q) => set({ searchQuery: q }),
  setSelectedId: (id) => set({ selectedId: id }),
  setFilters: (f) => set((s) => ({ filters: { ...s.filters, ...f } })),
  setClusteringEnabled: (value) => set({ clusteringEnabled: value }),
  centerOnById: (id, zoom) => set((s) => {
    const p = s.points.find((x) => x.id === id);
    if (!p || !s.viewer) return s;
    const { viewer, getItem } = s.viewer;
    const item = getItem?.();
    if (!item) return s;
    const pt = new OpenSeadragon.Point(p.xTL, p.yTL);
    const vpPoint = item.imageToViewportCoordinates(pt);
    if (zoom) {
      const vpZoom = item.imageToViewportZoom(zoom);
      viewer.viewport.zoomTo(vpZoom, vpPoint);
    }
    viewer.viewport.panTo(vpPoint);
    return s;
  }),
}));
